import type { ReactNode } from 'react'
import { cn } from '@/utils/cn'

export type ButtonVariant = 'primary' | 'ghost'

export type ButtonProps = {
  children: ReactNode
  type?: 'button' | 'submit' | 'reset'
  variant?: ButtonVariant
  disabled?: boolean
  className?: string
  onClick?: () => void
}

const variantClasses: Record<ButtonVariant, string> = {
  primary:
    'bg-ink text-surface border-2 border-ink hover:bg-ink-soft disabled:opacity-60',
  ghost:
    'bg-transparent text-ink border-2 border-ink hover:bg-paper disabled:opacity-60',
}

export function Button({
  children,
  type = 'button',
  variant = 'primary',
  disabled = false,
  className,
  onClick,
}: ButtonProps) {
  return (
    <button
      type={type}
      disabled={disabled}
      onClick={onClick}
      className={cn(
        'inline-flex items-center justify-center px-4 py-2.5 text-sm font-semibold transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent',
        variantClasses[variant],
        className,
      )}
    >
      {children}
    </button>
  )
}
